
import M_Layout_main from '@/mobile/layout/Main.vue' 
import M_Home from '@/mobile/Home.vue' 

//게시판
import M_Post from '@/mobile/pages/post/Post.vue'
import M_PostList from '@/mobile/pages/post/PostList.vue'
import M_PostView from '@/mobile/pages/post/PostView.vue'
import M_PostWrite from '@/mobile/pages/post/PostWrite.vue'
import M_PostSearch from '@/mobile/pages/post/PostSearch.vue'

//아이템
import M_ItemList from '@/mobile/Item.vue'
import M_Item from '@/mobile/pages/item/Item.vue'
import M_ItemView from '@/mobile/pages/item/ItemView.vue'
import M_PshopView from '@/mobile/pages/item/GoodsView.vue'

//채팅 로비
import M_ChatLobby from '@/mobile/ChatLobby.vue'

//로그인 회원가입
import M_Login from '@/mobile/pages/auth/Login.vue'
import M_Register from '@/mobile/pages/auth/Register.vue'

//내정보
import M_MyInfo from '@/mobile/pages/myinfo/MyInfo.vue'
import M_MyInfoEdit from '@/mobile/pages/myinfo/Edit.vue'

import M_MyInfoItem from '@/mobile/pages/myinfo/Item.vue'
    import M_MyInfoItemBuy from '@/mobile/pages/myinfo/ItemBuy.vue'
    import M_MyInfoItemUse from '@/mobile/pages/myinfo/ItemUse.vue'
    import M_MyInfoItemValidity from '@/mobile/pages/myinfo/ItemValidity.vue'

import M_MyInfoPshop from '@/mobile/pages/myinfo/GoodsBuy.vue'
import M_MyInfoRecommender from '@/mobile/pages/myinfo/Recommender.vue'
    import M_MyInfoRecommenderList from '@/mobile/pages/myinfo/RecommenderList.vue'
    import M_MyInfoRecommenderReward from '@/mobile/pages/myinfo/RecommenderReward.vue'

import M_MyInfoFriends from '@/mobile/pages/myinfo/Friends.vue'
import M_MyInfoPoint from '@/mobile/pages/myinfo/Point.vue'
import M_MyInfoPosts from '@/mobile/pages/myinfo/Posts.vue'
import M_MyInfoSelfAuth from '@/mobile/pages/myinfo/SelfAuth.vue'

//채팅
import M_ChatMain from '@/mobile/layout/Chat.vue' 
export default [   
        //채팅
        { name:'m_chat_main', path: '/m_chat/:room_id', component: M_ChatMain, props:true,
            children:[
                // { name:'m_chat_Lobby' , path:'lobby', component:ChatLobby },
                // { name:'chat_Default' , path:'default', component:ChatDefault },
                // { name:'chat_room' , props: true, path:'room/:room_id', component:ChatRoom },
                // { name:'chat_roomCreate', path:'create', component:ChatroomCreate },
                // {path:'dev', component:Dev},
                // { name:'chat_mtm', props:true, path:'mtm/:mtm_id', component:ChatMtm}
            ]
        },        
        {
            path:'/m',
            name:'m_Main',
            component:M_Layout_main, redirect :{ name: 'm_Home'},
                children: [
                    {name:'m_Home', path:'home', component:M_Home, props:true, },                    
                    
                    //게시판
                    { name:'m_post', path:'community', component: M_Post, redirect :{ name: 'm_postList'},
                        children:[
                            {name:'m_postList', path:':menu/:document', component:M_PostList, props:true,
                                children:[
                                    {name:'m_postView', path:'view/:id', component: M_PostView, props:true},
                                ]
                            },
                            {name:'m_postwrite', path:':document/write', component: M_PostWrite, props:true ,meta: { requiresAuthMobile: true }},
                            {name:'m_postsearch', path:'postsearch', component: M_PostSearch, props:true },
                            {name:'m_postsearch_view', path:'postsearch/view/:id', component: M_PostSearch, props:true },  
                        ]
                    },

                    //아이템 P샵 선택
                    { name:'m_ItemList', path:'itemlist', component:M_ItemList, props:true},
                    { name:'m_Item', path:'item', component:M_Item, redirect :{ name: 'm_itemView'},
                        children:[
                            { name:'m_itemView', path:'view/:id', component: M_ItemView, props:true },
                            { name:'m_pshopView', path:'pshopview/:id', component: M_PshopView, props:true },
                        ]
                    },

                    //채팅로비
                    { name:'m_ChatLobby', path:'chatlobby', component:M_ChatLobby, props:true},

                    //로그인 회원가입 
                    { name:'m_Login', path:'login', component:M_Login, prop:true},
                    { name:'m_Register', path:'register', component:M_Register, prop:true,meta: { requiresUnauthMobile: true }},
                    
                    //내정보
                    { name:'m_MyInfo', path:'myinfo', component:M_MyInfo, redirect :{ name: 'm_MyInfo_Edit'},
                        children:[
                            { name:'m_MyInfo_Edit', path:'edit', component: M_MyInfoEdit, props:true,meta: { requiresAuthMobile: true } },
                            { name:'m_MyInfo_Item', path:'item', component: M_MyInfoItem, props:true,redirect :{ name: 'm_MyInfo_Item_Buy'}, 
                                children:[
                                    { name:'m_MyInfo_Item_Buy', path:'buy', component: M_MyInfoItemBuy, props:true,meta: { requiresAuthMobile: true }},  
                                    { name:'m_MyInfo_Item_Use', path:'use', component: M_MyInfoItemUse, props:true,meta: { requiresAuthMobile: true }},   
                                    { name:'m_MyInfo_Item_Validity', path:'validity', component: M_MyInfoItemValidity, props:true,meta: { requiresAuthMobile: true },}    
                                ]
                            },
                            { name:'m_MyInfo_Pshop', path:'pshop', component: M_MyInfoPshop, props:true ,meta: { requiresAuthMobile: true }},
                            { name:'m_MyInfo_Recommender', path:'recommender', component: M_MyInfoRecommender, props:true, redirect :{ name: 'm_MyInfo_Recommender_Reward'},
                                children:[
                                    { name:'m_MyInfo_Recommender_List', path:'list', component: M_MyInfoRecommenderList, props:true,meta: { requiresAuthMobile: true }},
                                    { name:'m_MyInfo_Recommender_Reward', path:'reward', component: M_MyInfoRecommenderReward, props:true,meta: { requiresAuthMobile: true }},       
                                ]   
                            },
                            { name:'m_MyInfo_Friends', path:'friends', component: M_MyInfoFriends, props:true,meta: { requiresAuthMobile: true } },
                            { name:'m_MyInfo_Point', path:'point', component: M_MyInfoPoint, props:true ,meta: { requiresAuthMobile: true }},
                            { name:'m_MyInfo_Posts', path:'posts', component: M_MyInfoPosts, props:true ,meta: { requiresAuthMobile: true }},
                            { name:'m_MyInfo_SelfAuth', path:'selfauth', component: M_MyInfoSelfAuth, props:true ,meta: { requiresAuthMobile: true }},
                        ]
                    },
                ]
        },
        
    ]


